export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.e268722ac67dc747e7c3cff7dd93688d.css";